import theme from '../theme';

const telCategoryColor = (category: string) => {
  const telCategoryColors: {[key: string]: string} = theme.status.telCategory;
  return telCategoryColors[category];
};

export default telCategoryColor;
